<div class="breadcrumbs-wrapper">
  <div class="breadcrumbs">
    <app-futures-toggle-button></app-futures-toggle-button>

    <div class="breadcrumbs__items">
      @for (breadcrumb of breadcrumbs; track breadcrumb.route; let last = $last) {
        <div class="breadcrumbs__item">
          @if (!last) {
            <a
              href="javascript:;"
              class="breadcrumbs__link"
              (click)="navigateToUrl(breadcrumb.route)"
            >
              {{ breadcrumb.label }}
            </a>

            <app-svg-icon
              class="breadcrumbs__separator"
              [icon]="'assets/images/breadcrumb/separator.svg'"
              [blank]="true"
            />
          }

          @if (last) {
            <span class="breadcrumbs__label">{{ breadcrumb.label }}</span>
          }
        </div>
      }
    </div>
  </div>
</div>
